// extracted by mini-css-extract-plugin
export default {"mainBlock":"Main_mainBlock__vsZ00","greeting":"Main_greeting__a7YeJ","animateText":"Main_animateText__TjuHk","photoBlock":"Main_photoBlock__Ji2bE","photo":"Main_photo__ADd0i"};